import { pattern } from 'ngrx-forms/validation';
import { BuildValidatorWithComparandDecorator } from './helpers';

export const Pattern = BuildValidatorWithComparandDecorator<
  string,
  string,
  RegExp
>(pattern, 'DX.FORMS.VALIDATION.ERRORS.PATTERN');
